import { render, staticRenderFns } from "./HeaderTitleComponent.vue?vue&type=template&id=44034e3a&scoped=true&"
import script from "./HeaderTitleComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderTitleComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTitleComponent.vue?vue&type=style&index=0&id=44034e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44034e3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44034e3a')) {
      api.createRecord('44034e3a', component.options)
    } else {
      api.reload('44034e3a', component.options)
    }
    module.hot.accept("./HeaderTitleComponent.vue?vue&type=template&id=44034e3a&scoped=true&", function () {
      api.rerender('44034e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/header/HeaderTitleComponent.vue"
export default component.exports